import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import { useGetDetailRequests } from "../hooks";
import { Skeleton } from "antd";
import { Evidences } from "./evidences";
import { getUnitFromUnitID } from "../../../human-organization/summary-employee-request/utils/render-helper";

export const ExportInformation: FC = () => {
  const { data, isLoading } = useGetDetailRequests();
  if (isLoading) return <Skeleton />;

  return (
    <Box title="Thông tin xuất kho">
      <div className="list">
        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100">Người yêu cầu</p>
            <strong>{data.createdBy.user.displayName}</strong>
          </div>
        </div>

        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100">Cơ quan/Đơn vị</p>
            <strong>{data.fields.eDepartment}</strong>
          </div>
        </div>

        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100"> Đơn vị</p>
            <strong>
              {getUnitFromUnitID(
                data?.fields?.eDepartment,
                data?.fields?.eUnit
              )}
            </strong>
          </div>
        </div>

        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100">Đề nghị xuất kho</p>
            <strong>{data.fields.eTypeExportWarehouse}</strong>
          </div>
        </div>

        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100"> Số điện thoại</p>
            <strong>{data.fields.ePhoneNumber}</strong>
          </div>
        </div>

        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100"> Lý do</p>
            <strong>{data.fields.eReason}</strong>
          </div>
        </div>

        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100">Chứng cứ kèm theo (nếu có)</p>
            <Evidences evidences={JSON.parse(data?.fields?.eFileContent)} />
          </div>
        </div>
      </div>
    </Box>
  );
};
